import httpClient from "@plugins/http";

const fetchModulePackageCompletionInfo = (requestData) => {
  return httpClient.get(`/apis/attempt/progress/info?timestamp=${requestData.time}`, {
    params: requestData,
  });
};

const fetchModuleSectionCompletionInfo = (requestData) => {
  return httpClient.get(`/apis/attempt/progress/section-info`, {
    params: requestData,
  });
};

const fetchModuleSectionPageProgressInfo = (requestData) => {
  return httpClient.get(`/apis/attempt/progress/section/activity-info`, {
    params: requestData,
  });
};

const fetchModuleSectionQuizActivityInfo = (requestData) => {
  return httpClient.get(`/apis/attempt/progress/section/quiz-info`, {
    params: requestData,
  });
};

export default {
  fetchModulePackageCompletionInfo,
  fetchModuleSectionCompletionInfo,
  fetchModuleSectionPageProgressInfo,
  fetchModuleSectionQuizActivityInfo,
};
